import { createAsyncThunk } from '@reduxjs/toolkit';
import { setLoading } from '../global';

import { bearerAuth } from '../auth';
import axios from 'axios';


export const getWallets = createAsyncThunk(
    'Wallet/getWallets', ({jwtToken}: { jwtToken: string | undefined }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        return axios.get('/wallets', config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

export const resetWallet = createAsyncThunk(
    'Wallet/resetWallet', ({jwtToken, walletExternalKey}: { jwtToken: string | undefined, walletExternalKey: string }, thunkAPI) => {
        thunkAPI.dispatch(setLoading(true));
        console.log('QQQ jwtToken: ', jwtToken);
        const config = {
            headers: {'Authorization': bearerAuth(jwtToken)}
        };

        return axios.post('/wallets/' + walletExternalKey + "/reset", {}, config)
            .then(response => {
                return response.data
            })
            .finally(() => {
                thunkAPI.dispatch(setLoading(false));
            });
    },
);

